// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"cda322e6","703":"93e65a08","787":"30673c5e"}[chunkId] + ".chunk.js";
};